import { UNSET_AXIS_VALUES, UNSET_RATIO } from 'craft/components/SelectedToolbar/ImageCrop/constants';
import {
  axisValuesType,
  cropRatioValue,
  maxValuesType,
  resizeStartValuesType,
  sizeValuesType,
} from 'craft/components/SelectedToolbar/ImageCrop/types';

type CropReducerState = {
  isCropRatioActive: boolean;
  cropRatio: cropRatioValue;
  naturalSizeValues: sizeValuesType;
  originalSizeValues: sizeValuesType;
  sizeValues: sizeValuesType;
  maxValues: maxValuesType;
  axisValues: axisValuesType;
  isResizing: boolean;
  resizeStartValues: resizeStartValuesType;
};

export enum CropReducerActionTypes {
  ImageLoad = 'image-load',
  Revert = 'revert',
  RatioSelect = 'ratio-select',
  RatioChange = 'ratio-change',
  Resize = 'resize',
  ResizeStart = 'resize-start',
  ResizeEnd = 'resize-end',
  Drag = 'drag',
}

type ImageLoadAction = {
  type: CropReducerActionTypes.ImageLoad;
  payload: {
    naturalSizeValues: CropReducerState['naturalSizeValues'];
    originalSizeValues: CropReducerState['originalSizeValues'];
    maxValues: CropReducerState['maxValues'];
    sizeValues: CropReducerState['sizeValues'];
    axisValues: CropReducerState['axisValues'];
  };
};

type RevertAction = {
  type: CropReducerActionTypes.Revert;
};

type RatioSelectAction = {
  type: CropReducerActionTypes.RatioSelect;
  payload: {
    isCropRatioActive: CropReducerState['isCropRatioActive'];
    cropRatio: CropReducerState['cropRatio'];
  };
};

type RatioChangeAction = {
  type: CropReducerActionTypes.RatioChange;
  payload: {
    sizeValues: CropReducerState['sizeValues'];
    maxValues: CropReducerState['maxValues'];
    axisValues: CropReducerState['axisValues'];
  };
};

type ResizeAction = {
  type: CropReducerActionTypes.Resize;
  payload: {
    sizeValues: CropReducerState['sizeValues'];
    axisValues: CropReducerState['axisValues'];
  };
};

type ResizeStartAction = {
  type: CropReducerActionTypes.ResizeStart;
  payload: {
    resizeStartValues: CropReducerState['resizeStartValues'];
    maxValues: CropReducerState['maxValues'];
  };
};

type ResizeEndAction = {
  type: CropReducerActionTypes.ResizeEnd;
};

type DragAction = {
  type: CropReducerActionTypes.Drag;
  payload: {
    axisValues: CropReducerState['axisValues'];
  };
};

export type CropReducerActions =
  | ImageLoadAction
  | RevertAction
  | RatioSelectAction
  | RatioChangeAction
  | ResizeAction
  | ResizeStartAction
  | ResizeEndAction
  | DragAction;

export const reducer = (state: CropReducerState, action: CropReducerActions) => {
  switch (action.type) {
    case CropReducerActionTypes.Revert:
      return {
        ...state,
        isCropRatioActive: false,
        cropRatio: UNSET_RATIO,
        sizeValues: state.originalSizeValues,
        maxValues: {
          maxWidth: state.originalSizeValues.width,
          maxHeight: state.originalSizeValues.height,
        },
        axisValues: UNSET_AXIS_VALUES,
        isResizing: false,
      };
    case CropReducerActionTypes.ImageLoad:
      return {
        ...state,
        naturalSizeValues: action.payload.naturalSizeValues,
        originalSizeValues: action.payload.originalSizeValues,
        maxValues: action.payload.maxValues,
        sizeValues: action.payload.sizeValues,
        axisValues: action.payload.axisValues,
      };
    case CropReducerActionTypes.RatioSelect:
      return {
        ...state,
        isCropRatioActive: action.payload.isCropRatioActive,
        cropRatio: action.payload.cropRatio,
      };
    case CropReducerActionTypes.RatioChange:
      return {
        ...state,
        sizeValues: action.payload.sizeValues,
        maxValues: action.payload.maxValues,
        axisValues: action.payload.axisValues,
      };
    case CropReducerActionTypes.Resize:
      return {
        ...state,
        sizeValues: action.payload.sizeValues,
        axisValues: action.payload.axisValues,
      };
    case CropReducerActionTypes.ResizeStart:
      return {
        ...state,
        isResizing: true,
        resizeStartValues: action.payload.resizeStartValues,
        maxValues: action.payload.maxValues,
      };
    case CropReducerActionTypes.ResizeEnd:
      return {
        ...state,
        isResizing: false,
      };
    case CropReducerActionTypes.Drag:
      return { ...state, axisValues: action.payload.axisValues };
    default:
      throw new Error();
  }
};
